import { render, staticRenderFns } from "./backend-power.vue?vue&type=template&id=60392392&"
import script from "./backend-power.vue?vue&type=script&lang=js&"
export * from "./backend-power.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports